import React, { useContext, useEffect } from 'react';

import moment from 'moment';
import { Calendar, momentLocalizer } from 'react-big-calendar';

import { AssignContext, AssignDispatchContext } from '../AssignProvider';

import Button from 'CommonComponents/Button';

import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment);

export default function VenueCalendar(props) {
    const { venues, selectedVenue, selectedDate, calendarEvents } = useContext(AssignContext);
    const assignAction = useContext(AssignDispatchContext);

    const handleVenueChange = (e) => {
        assignAction('selectVenue', { id: e.target.value });
    };

    useEffect(() => {
        navigateDates(selectedDate);
    }, [selectedVenue]);

    const NoVenues = () => {
        return <div className="tw-text-sm tw-text-charcoal-50">{$t('No venues found')}</div>;
    };

    const handleSelect = (e) => {
        assignAction('selectDates', { dates: e.slots });
        assignAction('selectDate', { date: e.slots[0] });
    };

    const handleClear = () => {
        assignAction('clearDates', { dates: [] });
    };

    const VenuesSelect = () => {
        return (
            <select className="tw-border-0 select-input tw-space-y-1.5" value={selectedVenue?.id} onChange={handleVenueChange}>
                {venues.map((venue, i) => {
                    return (
                        <option key={i} value={venue.id}>
                            {venue.name}
                        </option>
                    );
                })}
            </select>
        );
    };

    const navigateDates = (focusDate) => {
        if (focusDate) {
            const venueHireStart = moment(selectedVenue.hire_start);
            const venueHireEnd = moment(selectedVenue.hire_end);
            const momentFocusDate = moment(focusDate);

            if (momentFocusDate.isAfter(venueHireEnd) && momentFocusDate.month() != venueHireEnd.month()) {
                assignAction('selectDate', { date: venueHireEnd.toDate() });
            } else if (momentFocusDate.isBefore(venueHireStart) && momentFocusDate.month() != venueHireStart.month()) {
                assignAction('selectDate', { date: venueHireStart.toDate() });
            } else {
                assignAction('selectDate', { date: momentFocusDate.toDate() });
            }
        }
    };

    return (
        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-p-2.5 tw-space-y-4">
            <div className="tw-flex tw-items-center tw-gap-x-2">
                {(!!venues.length && <VenuesSelect />) || <NoVenues />}
                <Button small as="a" variant="primary" style={{ minWidth: 'fit-content' }} onClick={handleClear}>
                    {$t('Clear dates')}
                </Button>
            </div>
            {selectedDate && (
                <Calendar
                    events={calendarEvents}
                    defaultDate={selectedDate}
                    date={selectedDate}
                    localizer={localizer}
                    startAccessor="start"
                    endAccessor="end"
                    views={['month']}
                    style={{ height: 500 }}
                    onSelectSlot={handleSelect}
                    selectable={true}
                    components={{
                        dateCellWrapper: CalendarDayComponent,
                    }}
                    onNavigate={(focusDate) => {
                        navigateDates(focusDate);
                    }}
                />
            )}
        </div>
    );
}

const CURRENT_DATE = moment().toDate();
const CalendarDayComponent = ({ children, value }) => {
    const { selectedDates } = useContext(AssignContext);
    let dayElementClass = 'rbc-day-bg';
    if (selectedDates) {
        selectedDates.forEach((val) => {
            dayElementClass += moment(val).isSame(value, 'day') ? ' selected-date' : '';
            dayElementClass += moment(CURRENT_DATE).isSame(value, 'day') ? ' current-date' : '';
        });
    }
    return React.cloneElement(children, {
        className: `${children.props.className || ''} ${dayElementClass}`.trim(),
    });
};
